/** Adds a value that is missing, or removes it when present (multi-selects). */
export function toggleValue(list: readonly string[], value: string): string[] {
  return list.includes(value) ? list.filter((item) => item !== value) : [...list, value];
}

/** Adds every value that is missing (`on`), or removes them all (a "select all" box). */
export function setValues(
  list: readonly string[],
  values: readonly string[],
  on: boolean,
): string[] {
  const changed = new Set(values);
  const rest = list.filter((item) => !changed.has(item));
  return on ? [...rest, ...changed] : rest;
}
